import React from 'react';
import { money } from './money';

export default function LedgerTariffChanges({ details }) {
  if (details?.source !== 'operation-tariff-change') return null;
  const before=details.before||{}, after=details.after||{};
  const bands=[...new Set([...(before.bands||[]),...(after.bands||[])].map(b=>b.band))];
  const changes=bands.map(band=>({band,previous:before.bands?.find(b=>b.band===band),current:after.bands?.find(b=>b.band===band)}))
    .filter(({previous,current})=>JSON.stringify(previous)!==JSON.stringify(current));
  const display=band=>band?`${band.from}–${band.to} h: ${money(band.value)}`:'Sin definir';
  return <details className="er-tariff-changes"><summary>Ver cambios de tarifa</summary>
    {before.categoria!==after.categoria&&<p>Categoría: {before.categoria} → {after.categoria}</p>}
    {before.activo!==after.activo&&<p>Estado: {before.activo?'Activa':'Inactiva'} → {after.activo?'Activa':'Inactiva'}</p>}
    {changes.map(({band,previous,current})=><p key={band}><strong>{band}</strong><br/>{display(previous)} → {display(current)}</p>)}
  </details>;
}
